module.exports = __webpack_public_path__ + "static/img/h_30@2x.1ac69222.png";